<template>
  <component
    :is="as"
    @click="$emit('click')"
    :style="`width: ${width}px; height: ${height}px;`"
    :class="[bg, { 'm-auto': center }, { 'rounded-circle': circle }]"
  >
    <img
      v-if="customSvgColor"
      class="img-fluid"
      :class="`bg-${color}`"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA
           AEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII="
      :style="customStyle"
      :alt="icon"
    />
    <img v-else class="img-fluid" :src="svgSrc" :width="width" :height="height" :alt="icon" />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import svgIcon from '@/constants/svgIcon'

type SvgIconProps = {
  icon: string
  width?: number | string
  height?: number | string
  circle?: boolean
  bg?: string
  color?: string
  center?: boolean
  as?: 'div' | 'span' | 'a'
  display?: 'block' | 'inline-block' | 'inline'
}

const props = withDefaults(defineProps<SvgIconProps>(), {
  width: svgIcon.SVG_ICON_EXTERNAL_DEFAULT_WIDTH,
  height: svgIcon.SVG_ICON_EXTERNAL_DEFAULT_HEIGHT,
  circle: true,
  bg: '',
  color: 'white',
  center: false,
  as: 'div',
  display: 'block'
})

const customStyle = computed(() => ({
  display: props.display,
  maskRepeat: 'no-repeat',
  maskPosition: 'center',
  maskSize: 'cover',
  margin: 'auto',
  width: `${props.width}px`,
  height: `${props.height}px`,
  maskImage: 'url("' + svgSrc.value + '")'
}))

const customSvgColor = computed<boolean>(() => props.color !== 'initial')

const svgSrc = computed<string>(
  () => new URL(`/src/assets/svg/${props.icon}.svg`, import.meta.url).href
)
</script>
